
































































































































import OtButton from '@/components/global/ot-button.vue';
import OtTag, { TagStatus } from '@/components/global/ot-tag.vue';
import { OtStatusType } from '@/types/status-enums';
import { formatDateAndTime } from '@/utils/date-utils';
import { Component, Prop, Vue } from 'vue-property-decorator';
import OtExpansionPanel from '@/components/global/ot-expansion-panel.vue';
import { OtOrganisationStatus, UserProfile } from './models';
import { doAconexAuth } from '@/services/aconex.service';
import OtApi, { executeApi } from '@/services/api.service';
import { vxm } from '@/store';

@Component({
  components: {
    OtTag,
    OtButton,
    OtExpansionPanel,
  },
})
export default class OtProfileDetails extends Vue {
  // * PROPS
  @Prop() private userProfile!: UserProfile;

  // * REFS

  // * DATA
  private isAconexConnecting = false;
  private api = new OtApi();
  // * COMPUTED

  private get isAconexConnected() {
    return this.userProfile.aconexUserInformation !== null;
  }

  // * WATCHERS

  // * METHODS
  private formatDateAndTime(date: Date) {
    return formatDateAndTime(date);
  }

  private getTagStatus(status: OtOrganisationStatus): TagStatus {
    return { type: OtStatusType.Organisation, status };
  }

  private async disconnectAconex() {
    this.isAconexConnecting = true;
    const apiResult = await executeApi(() => this.api.aconex().postRemoveAconexAccessToken(), 'Logout from Aconex');
    if (apiResult.success) {
      await vxm.userProfile.getUserProfile({ forceReload: true });
    }
    this.isAconexConnecting = false;
  }

  private async connectAconex() {
    this.isAconexConnecting = true;
    const result = await doAconexAuth();
    this.isAconexConnecting = false;
    console.log('aconex auth complete', result);
  }

  // * LIFECYCLE
}
